import React, { useState } from "react";
import { ScoodleDefaultPage } from "../../../04templates/scoodle/defaultPage/ScoodleDefaultPage";
import { Body3, H1 } from "pu-crossproduct-components/build/components/Atoms/Type";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import { Button, ButtonColors, Size } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import { Link, LinkColors } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import styled from "styled-components";
import { Scoodle2FAExplanation } from "../Scoodle2FAExplanation/Scoodle2FAExplanation";

const ButtonContainer = styled.div`
    button {
        width: 383px;
    }
`;

interface IScoodle2FAFailed {
    onRetry: () => void;
}

export const Scoodle2FAFailed: React.FC<IScoodle2FAFailed> = props => {
    const { t } = useTranslation();

    return <ScoodleDefaultPage>

        <GridContainer>
            <GridRow>
                <GridItem col={0} laptop={2} />
                <GridItem col={12} laptop={8}>
                    <div style={{ textAlign: "center" }}>
                        <H1>{t('twoFactorScoodleFailedTitle')}</H1>
                        <br />
                        <Body3>{t('twoFactorScoodleFailedBody')}</Body3>
                    </div>
                </GridItem>
            </GridRow>
        </GridContainer>

        <br />
        <br />
        <br />

        <ButtonContainer>
            <Button size={Size.large} onClick={props.onRetry}>{t('twoFactorScoodleFailedRetryButton')}</Button>
        </ButtonContainer>
    </ScoodleDefaultPage >
}